import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const PageTitle = ({ title, description }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    // Set page title
    if (title) {
      const siteTitle = currentLang === 'ru' ? 'FotografX' : 'FotografX';
      document.title = `${title} | ${siteTitle}`;
    }

    // Set meta description if provided
    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
    }
  }, [title, description, currentLang]);

  return null; // This component doesn't render anything
};

export default PageTitle;